import { Service } from './Service';
import { ErrorWrapper, ResponseWrapper } from '@/services/util';

export class StatisticsService extends Service {
  static get endpoint() {
    return 'statistics';
  }

  static async getRequestVacationConflictReports() {
    try {
      const response = await this.request({ auth: true }).get(
        `${this.endpoint}/conflicts-aggregate`
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}
